import { useInfiniteQuery } from "@tanstack/react-query";
import { getProductStockHistory } from "../services/productService";

/**
 * Hook for fetching stock history with infinite scroll support
 * @param {string} productId - Product ID
 * @param {Object} filters - Filter parameters
 * @returns {Object} React Query infinite query result
 */
export function useStockHistoryInfiniteQuery(productId, filters = {}) {
  return useInfiniteQuery({
    queryKey: ["stockHistory", productId, filters],
    queryFn: async ({ pageParam = 1 }) => {
      const params = {
        page: pageParam,
        limit: 20, // Items per page
      };

      // Add filters
      if (filters.adjustmentType && filters.adjustmentType !== "all") {
        params.adjustmentType = filters.adjustmentType;
      }
      if (filters.dateRange?.from) {
        params.startDate = filters.dateRange.from.toISOString();
      }
      if (filters.dateRange?.to) {
        params.endDate = filters.dateRange.to.toISOString();
      }
      if (filters.isValidated && filters.isValidated !== "all") {
        params.isValidated = filters.isValidated;
      }
      if (filters.referenceType && filters.referenceType !== "all") {
        params.referenceType = filters.referenceType;
      }

      return await getProductStockHistory(productId, params);
    },
    getNextPageParam: (lastPage) => {
      return lastPage.pageInfo?.hasNextPage
        ? lastPage.pageInfo.currentPage + 1
        : undefined;
    },
    enabled: !!productId,
    staleTime: 1000 * 60, // 1 minute
  });
}
